import { Link } from "react-router-dom";
import StatusBadge, { statusActionLabel } from "./StatusBadge";
import WCButton from "./WCButton";

export const DropCard = ({ drop, size = "md" }) => {
  const large = size === "lg";
  const target = drop.slug === "guatemala-drop" || drop.slug === "system-drop"
    ? `/${drop.slug}`
    : "/drops";
  const archived = drop.status === "archived" || drop.status === "sold_out";
  return (
    <div className="wc-drop-card group block" data-testid={`drop-card-${drop.slug}`}>
      <Link to={target}>
        <div
          className={`relative overflow-hidden ${large ? "aspect-[4/3]" : "aspect-square"} bg-[#0a0a0a]`}
        >
          <img
            src={drop.image}
            alt={drop.name}
            loading="lazy"
            className="wc-image w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          {archived && (
            <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
              <span className="wc-label text-xs text-white border border-white px-4 py-2">
                SOLD OUT
              </span>
            </div>
          )}
        </div>
      </Link>
      <div className="py-6">
        <div className="wc-label text-[10px] text-white/50">{drop.category}</div>
        <div className="wc-label text-[10px] text-white/50 mt-1">{drop.volume}</div>
        <Link to={target}>
          <h3 className="wc-heading text-white text-3xl md:text-4xl mt-3 tracking-widest">
            {drop.name}
          </h3>
        </Link>
        <div className="text-sm text-white/70 mt-2">
          {drop.location} — {drop.date}
        </div>
        <div className="mt-4">
          <StatusBadge status={drop.status} />
        </div>
        <div className="mt-6">
          <WCButton
            as="link"
            to={target}
            disabled={drop.status === "sold_out"}
            data-testid={`drop-cta-${drop.slug}`}
          >
            {statusActionLabel(drop.status)}
          </WCButton>
        </div>
      </div>
    </div>
  );
};

export default DropCard;
